



















import { computed, defineComponent, toRefs } from '@vue/composition-api';
const name = 'ttam-sidebar-delete-dialog';
enum CreationStep {
  campaign = 'campaign',
  adgroup = 'adgroup',
  creative = 'creative',
}
export default defineComponent({
  name,
  props: {
    curLevel: {
      type: String,
      default: CreationStep.campaign,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { curLevel } = toRefs(props);
    const dialogInfo = computed(() => {
      switch (curLevel.value) {
        case CreationStep.campaign:
          return {
            title: 'creation_1nn_delete_campaign_hint_title',
            content: 'creation_1nn_delete_campaign_hint_msg',
            cancelButton: 'common_cancel',
            confirmButton: 'creation_1nn_delete_campaign_confirm',
          };
        case CreationStep.adgroup:
          return {
            title: 'creation_1nn_delete_adgroup_hint_title',
            content: 'creation_1nn_delete_adgroup_hint_msg',
            cancelButton: 'common_cancel',
            confirmButton: 'common_delete',
          };
        case CreationStep.creative:
          return {
            title: 'creation_1nn_delete_ad_hint_title',
            content: 'creation_1nn_delete_ad_hint_msg',
            cancelButton: 'common_cancel',
            confirmButton: 'common_delete',
          };
        default:
          return {};
      }
    });

    const handleOpen = () => {
      emit('open');
    };

    const handleCancel = () => {
      emit('click-cancel');
      emit('close');
    };
    const handleDelete = () => {
      emit('click-confirm');
      emit('delete', curLevel.value);
      emit('close');
    };
    return {
      name,
      dialogInfo,
      handleOpen,
      handleCancel,
      handleDelete,
    };
  },
});
